// extracted by mini-css-extract-plugin
module.exports = {"customers":"Demand_customers_3_vKt","customer":"Demand_customer_36QcZ"};